import { AuditableResponse } from "../common/AuditableResponse"
import { InventoryTypeField } from "./InventoryTypeField"

export class InventoryTypeDetails extends AuditableResponse {
  id: number
  displayOrder: number
  name: string
  inventoryTypeFields: InventoryTypeField[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, displayOrder?: number, name?: string, inventoryTypeFieldsJson?: any, createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)
    this.id = id
    this.displayOrder = displayOrder ?? 1
    this.name = name ?? ''
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.inventoryTypeFields = inventoryTypeFieldsJson ? inventoryTypeFieldsJson.map((i: any) => new InventoryTypeField(i.id, i.displayOrder, i.name, i.type, i.isRequired, i.inventoryTypeFieldOptions)) : []
  }
}
